
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 260 170"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0053A5","d":"M0 0h260v170H0z"}}),_c('g',{attrs:{"fill":"#FFCE00"}},[_c('path',{attrs:{"d":"M80 0h50v170H80z"}}),_c('path',{attrs:{"d":"M0 60h260v50H0z"}})]),_c('g',{attrs:{"fill":"#D21034"}},[_c('path',{attrs:{"d":"M95 0h20v170H95z"}}),_c('path',{attrs:{"d":"M0 75h260v20H0z"}})])])
          )
        }
      }
    